export const ErrorViewGrid = {
	size: 100,
	gap: 0,
	name: 'error_holder',
	padding: {
		top: 10,
		bottom: 20
		// portrate: {
		//     left: 10,
		//     right: 10,
		// }
	},
	main: [
		{
			name: 'errorgrid',
			size: 100,
			type: 'PortrateGridController',
			config: {
				name: 'errorgrid2',
				size: 100,
				gap: 0,
				main: [
					{
						name: 'empty',
						size: 30
					},
					{
						name: 'error_img',
						size: 40,
						bounds: {
							width: 400,
							height: 400
						},
						// height: 60,
						align: 'bottom_center'
					},
					{
						name: 'error_info',
						size: 40,
						align: 'top',
						height: 30
					}
				]
			}
		}
	],
	landscape: [
		{
			name: 'errorgrid-landscape',
			size: 100,
			type: 'PortrateGridController',
			config: {
				name: 'errorgrid22',
				size: 100,
				gap: 0,
				main: [
					{
						name: 'empty',
						size: 30
					},
					{
						name: 'error_img',
						size: 40,
						bounds: {
							width: 196,
							height: 305
						},
						// height: 60,
						align: 'bottom_center'
					},
					{
						name: 'error_info',
						size: 40,
						align: 'top',
						height: 30
					}
				]
			}
		}
	],
	portrate: [
		{
			name: 'empty',
			size: 30
		},
		{
			name: 'error_img',
			size: 40,
			bounds: {
				width: 196,
				height: 305
			},
			// height: 60,
			align: 'bottom_center'
		},
		{
			name: 'error_info',
			size: 40,
			align: 'top'
			// height: 60,
		}
	]
};
